import { AxiosInstance } from 'axios';

// �F�؏��API�x�[�XURI
const resource = '/Auth';

/**
 * �F�؏��API�ďo���N���X
 */
export default class AuthRepository {

    constructor(private repository: AxiosInstance) { }

    /**
     * ���J���擾
     * @param id - ���O�C��ID
     * @return �`�������W�L�[
     */
    public async getPublicKey(id: string): Promise<string> {
        // �p�����[�^�ݒ�
        const apiParams = { loginId: id };
        // API�ďo��
        const response = await this.repository.post<string>(`${resource}/public-key`, apiParams);
        return response.data;
    }

    /**
     * ���O�C�����s
     * @param id - ���O�C��ID
     * @param password - �p�X���[�h
     * @return �F�؃I�u�W�F�N�g
     */
    public async login(id: string, password: string): Promise<AuthType.AuthInfo> {
        // �p�����[�^�ݒ�
        const apiParams = { loginId: id, passwordRSA: password };
        // API�ďo��
        const response = await this.repository.post<AuthType.AuthInfo>(`${resource}/login`, apiParams);
        const auth = response.data;
        if (auth == null) {
            // ���X�|���X����̏ꍇ�G���[
            throw new Error("response is null");
        }
        return auth;
    }

    /**
     * �F�؃R�[�h���M
     * @param destination - ���M��
     * @param type - ���M��� 0:SMS 1:���[��
     * @return �F�؃I�u�W�F�N�g
     */
    public async sendAuthCode(destination: string, type: number): Promise<boolean> {
        // �p�����[�^�ݒ�
        const apiParams = { destination, type };
        // API�ďo��
        const response = await this.repository.post(`${resource}/send-auth-code`, apiParams);
        return true;
    }

    /**
     * �F�؃R�[�h����
     * @param authCode - �F�؃R�[�h
     * @return ����
     */
    public async verifyAuthCode(authCode: string): Promise<boolean> {
        // API�ďo��
        await this.repository.get(`${resource}/verify-auth-code?authCode=` + authCode);
        return true;
    }

    /**
     * �p�X���[�h���}�C���_�[����
     * @param reminddata - ���M��
     * @return 
     */
    public async passwordReminder(reminddata: string): Promise<boolean> {

        const apiParams = {
            mailOrPhone: reminddata
        };

        // API�ďo��
        const response = await this.repository.post<boolean>(`${resource}/reminder`, apiParams);
        return true;
    }

    /**
     * ���}�C���h�`�F�b�N����
     * @remindCheckString - ���}�C���h�`�F�b�N������
     * @accountId - ���O�C��ID
     * @password - �A�J�E���gID
     * @return ����
     */
    public async passwordRemindCheck(remindCheckString: string, accountId:number): Promise<boolean> {

        const apiParams = {
            remindCheckString: remindCheckString,
            accountId: accountId
        };

        // API�ďo��
        const response = await this.repository.post<boolean>(`${resource}/remind-check`, apiParams);
        return true;
    }

    /**
     * �p�X���[�h���Z�b�g����
     * @accountId - �A�J�E���gID
     * @passwordRsa - �p�X���[�h
     * @return ����
     */
    public async passwordReset(accountId: number, passwordRsa:string): Promise<boolean> {

        const apiParams = {
            accountId: accountId,
            passwordRsa: passwordRsa
        };

        // �p�X���[�h���Z�b�gAPI�ďo��
        const response = await this.repository.post<boolean>(`${resource}/password-reset`, apiParams);
        return true;
    }

    /**
     * �p�X���[�h�ύX����
     * @param password - �p�X���[�h
     * @return �G���[�R�[�h
     */
    public async passwordChange(passwordRsa: string): Promise<boolean> {

        const apiParams = {
            passwordRsa: passwordRsa
        };

        // �p�X���[�h�ύXAPI�ďo��
        const response = await this.repository.post<boolean>(`${resource}/password-change`, apiParams);
        return true;
    }
}